module.exports = __webpack_public_path__ + "img/apps.1190be6f.svg";